import { createSlice } from '@reduxjs/toolkit'

// This state handles toggling the course add on popups
export const addOnPopupTogglesSlice = createSlice({
  name: 'addOnPopupToggles',
  initialState: {
    value: {},
  },
  reducers: {
    // toggle the pop up for the course add on
    toggleIndex: (state, action) => {
      state.value = {[action.payload]: !state.value[action.payload]};
    }
  },
})

// Action creators are generated for each case reducer function
export const { toggleIndex } = addOnPopupTogglesSlice.actions

export default addOnPopupTogglesSlice.reducer